import { render, staticRenderFns } from "./u-textarea-filled-tile.vue?vue&type=template&id=06b2b664&scoped=true&"
import script from "./u-textarea-filled-tile.vue?vue&type=script&lang=js&"
export * from "./u-textarea-filled-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b2b664",
  null
  
)

export default component.exports